import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

// eslint-disable-next-line import/prefer-default-export
export const Container = styled(Box)`
  background: #fff;
  border: #D4D4D6 1px solid;
  border-radius: 4px;
  padding: 12px 16px;
  background-image: linear-gradient(-18deg, #d4f4ff, #d4f4ff 30px, #fff 20px, #fff 30px);
  gap: 16px;
  align-items: flex-start;
  flex-direction: row;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 23.1px;
  color: #3E3E47;

  margin-bottom: 12px;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    margin-bottom: 8px;
  }
`

export const Title = styled.span`
  font-weight: 600;
`

export const TextBody = styled(Box)`
  font-weight: 400;
`

export const LearnMore = styled.span`
  color: #333;
  text-decoration: underline;
`
